import React from "react";
import { Text4, Text5 } from "../../../styles";
import { printRupee } from "../../../app_methods";
import moment from "moment";
import { Badge, Icon, Button, Menu, Dropdown } from "antd";
import { PermissionHoc } from "../../HOC";

const WritePermissableButton = PermissionHoc(Menu.Item, "DIRECT_TAX_CHALLAN_WRITE", { is_component: true, fallbackComponent: null })


export const MAJOR_HEAD_CHOICES = {
  "0020": { 'label': '0020-Company Deductees', "merchant_status": "0020_company_deductees" },
  "0021": { 'label': '0021-NonCompany Deductees', "merchant_status": "0021_noncompany_deductees" }
}

export const MINOR_HEAD_CHOICES = {
  "200": { 'label': 'Payable By Taxpayer (200)', "merchant_status": "payable_by_taxpayer_(200)" },
  "400": { 'label': 'Regular Assessment (400)', "merchant_status": "regular_assessment_(400)" }
}

export const CHALLAN_NUMBER_CHOICES = {
  '281': { 'label': "Challan No. / ITNSNo. 281 ", "merchant_status": "Challan No. / ITNSNo. 281 ", "detail": "Payment of TDS/TCS by Company or Non Company Deductee." },
  // '281': { 'label': "Challan No. / ITNSNo. 281 ", "merchant_status": "Challan No. / ITNSNo. 281 ", "detail": "Payment of TDS/TCS by Company or Non Company Deductee." },
  // '282': { 'label': "Challan No. / ITNSNo. 281 ", "merchant_status": "Challan No. / ITNSNo. 281 ", "detail": "Payment of TDS/TCS by Company or Non Company Deductee." },
  // '283': { 'label': "Challan No. / ITNSNo. 281 ", "merchant_status": "Challan No. / ITNSNo. 281 ", "detail": "Payment of TDS/TCS by Company or Non Company Deductee." }

}

export const ASSESSMENT_YEAR = ["2023-24", "2022-23", "2021-22", "2020-21", "2019-20", "2018-19", "2017-18", "2016-17", "2015-16"]

export const STATUSTYPES = {
  paid: {
    key: "paid",
    value: 3,
    label: "Paid",
    color: "green",
    description: "Direct Tax Challan is paid & Debit Advice has been generated.",
  },
  processing: {
    key: "processing",
    value: 2,
    label: "Processing",
    color: "blue",
    description: "Direct Tax Challan payment is initiated but is pending at bank's end.",
  },
  unpaid: {
    key: "unpaid",
    value: 1,
    label: "Unpaid",
    color: "orange",
    description: "Direct Tax Challan payment is not yet initiated.",
  },
  unapproved: {
    key: "unapproved",
    value: 4,
    label: "Unapproved",
    color: "yellow",
    description: "Direct Tax Challan payment is waiting for approval.",
  },
  cancelled: {
    key: "cancelled",
    value: 5,
    label: "Cancelled",
    color: "grey",
    description: "Direct Tax Challan payment is cancelled.",
  }
}

export const PAYMENT_STATUSTYPES = {
  pending: {
    key: "pending",
    value: 1,
    label: "Pending",
    color: "yellow",
  },
  in_process: {
    key: "in_process",
    value: 2,
    label: "In Process",
    color: "blue",
  },
  success: {
    key: "success",
    value: 3,
    label: "Success",
    color: "green",
  },
  reversed: {
    key: "reversed",
    value: 4,
    label: "Reversed",
    color: "orange",
  },
  failure: {
    key: "failure",
    value: 5,
    label: "Failure",
    color: "red",
  }
}

export const getDirectTaxColumns = (methods, current_user) => [
  {
    title: "MRN",
    key: "internal_request_number",
    render: (record) => <Text4>{record.internal_request_number || "---"}</Text4>,
  },
  {
    title: "Assessment Year",
    key: "assessment_year",
    render: (record) => <Text4>{record.assessment_year || "---"}</Text4>,
  },
  {
    title: "TAN",
    key: "tan",
    render: (record) => <Text4>{record.tan || "---"}</Text4>,
  },
  {
    title: "Amount",
    key: "amount",
    render: (record) => (
      <Text4>{printRupee(record.total_amount || "---")}</Text4>
    ),
  },
  {
    title: (
      <span className="c-pointer" onClick={methods.toggleStatusInfoDrawer}>
        <span>Status</span>
        <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
      </span>
    ),
    key: "status",
    render: (record) => (
      <Text4>
        {<Badge color={STATUSTYPES[record.status.toLowerCase()].color} text={<Text4>{STATUSTYPES[record.status.toLowerCase()].label}</Text4>} />}
      </Text4>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <Text4>
        <Button onClick={() => methods.toggleDirectTaxDetailsDrawer(record)} type="link">
          View details
        </Button>
      </Text4>
    ),
  },
];

export const direct_taxTableFilterNodes = (params = {}) => {

  const fy = [
    {
      id: 1,
      value: "2020 - 2021",
    },
    {
      id: 2,
      value: "2018 - 2019",
    },
    { id: 3, value: "2017 - 2018" },
  ];

  return [
    {
      label: "Amount",
      field: "amount",
      placeholder: "Amount",
      inputType: "text",
      defaultValue: "",
    },
    {
      label: "Assessment year",
      field: "assessment_year",
      placeholder: "Assessment year",
      inputType: "select",
      defaultValue: undefined,
      options: ASSESSMENT_YEAR.map((year) => {
        let object = {};
        object.key = year;
        object.value = year;
        object.label = (<Text4>{year}</Text4>);
        return object;
      }),
    },
    {
      label: "Status",
      field: "status",
      placeholder: "Status",
      inputType: "select",
      defaultValue: undefined,
      options: Object.keys(STATUSTYPES).map((type, index) => {
        let object = {};
        object.key = index;
        object.value = STATUSTYPES[type].value;
        object.label = (
          <Badge
            color={STATUSTYPES[type].color}
            text={<Text4>{STATUSTYPES[type].label}</Text4>}
          />
        );
        return object;
      }),
    },
  ];
};
